import { css } from 'styled-components';
import { RadioItem } from '../../../../../components/Form/RadioInput/styles';
import spacing from '../../../../../helpers/spacing';
import {
  applySelectorStyling,
  SelectorStyles,
} from '../../../../../helpers/themeHelpers';
import { colors, themeSpecificColors } from '../../../colors';

export const radioSelectorStyles: SelectorStyles = {
  baseStyles: css`
    border: solid 1px ${colors.core01};
    border-radius: 0;
    box-shadow: none;
    padding: ${spacing(1.5)} ${spacing(3)};
    background-color: ${colors.neutral08};
  `,
  hoverStyles: css`
    box-shadow: none;
    border-width: 2px;
  `,
  focusStyles: css`
    outline: solid 4px ${themeSpecificColors.core01_60};
    outline-offset: ${spacing(0.2)};
  `,
  selectedStyles: css`
    background-color: ${themeSpecificColors.core01_20};
    border: solid 1px ${colors.core01};
  `,
  activeStyles: css`
    background-color: ${themeSpecificColors.core01_20};
    border: solid 1px ${colors.core01};
    border-width: 2px;
  `,
};

export default css`
  ${applySelectorStyling(RadioItem, radioSelectorStyles)}
`;
